// components/VideoCard.tsx
import Link from "next/link";

interface VideoCardProps {
  title: string;
  category: string;
  tag: string;
  image: string;
  link?: string; // Add link prop
}

export default function VideoCard({ title, category, tag, image, link }: VideoCardProps) {
  return (
    <Link href={link || "#"}>
      <div className="bg-white shadow-lg rounded-lg overflow-hidden w-64 cursor-pointer hover:scale-105 transition-transform duration-200">
        <img src={image} alt={title} className="w-full h-40 object-cover" />
        <div className="p-4">
          <h3 className="font-semibold text-lg">{title}</h3>
          <p className="text-sm text-gray-500">{category}</p>
        </div>
      </div>
    </Link>
  );
}
